import { render, staticRenderFns } from "./ISwitch.vue?vue&type=template&id=1ed665ea&"
import script from "./ISwitch.vue?vue&type=script&lang=js&"
export * from "./ISwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports